export function savePages(state){
    return {
      type: 'SAVE_PAGES',
      payload: state
    }
  };